import SplashLogo from '@/assets/icons/splash_screen_logo.svg?react';
import E_Aqua from '@/assets/icons/e_aqua.svg?react';

export function SplashScreen() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-white bg-[radial-gradient(62.28%_62.63%_at_50%_50%,_rgba(255,_255,_255,_0)_0%,_rgba(12,_165,_162,_0.2)_100%)]">
      <SplashLogo />
      {/* todo replace this asset, I've asked Venessa to give the file */}
      <E_Aqua className="absolute bottom-4" />
    </div>
  );
}
